export default "__VITE_ASSET__CMZK$S8P__"